export const NetworkTypes = {
  Organisation: 1,
  WaitingArea: 9,
  MeetingRoom: 5,
  GroupConsultation: 12,
};
